export enum TabSmallTheme {
  Orange = 'orange',
  White = 'white',
  Transparent = 'transparent',
  Gray = 'gray',
  WithOutline = 'withOutline'
}
